import { createContext, useContext } from 'react';
export var CollapsibleContext = /*#__PURE__*/createContext({});
export var useCollapsibleContext = function () {
  return useContext(CollapsibleContext);
};